import type { User } from "@repo/baseCloud";
import type { EnrollmentValidationError } from "@repo/models";
import type { GridList } from "@repo/ui";

import { BaseController, BaseGridApi } from "@repo/baseCloud";

import type { EnrollmentValidationFilter } from "../pages/enrollmentValidation/types";

export const controller = "EnrollmentValidation";
const gridFiltersController = "GridFilters";

export default class EnrollmentValidationApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);
	static GetGridFilters = BaseController.GetFn(gridFiltersController);

	static getEnrollmentValidations(filter: EnrollmentValidationFilter) {
		return EnrollmentValidationApi.Get<GridList<EnrollmentValidationError>>("GetEnrollmentValidations", filter);
	}

	static saveEnrollmentValidation(eve: EnrollmentValidationError, email = false) {
		return EnrollmentValidationApi.Post<number>("SaveEnrollmentValidationError", null, { eve, email });
	}

	static review(eve: Partial<EnrollmentValidationError>) {
		return EnrollmentValidationApi.Post<number>("Review", null, { eve });
	}

	static getTypes() {
		return EnrollmentValidationApi.Get<{ Id: number; Name: string }[]>("GetTypes");
	}

	static getUsers() {
		return EnrollmentValidationApi.GetGridFilters<User[]>("GetUsers", { adminsOnly: true });
	}

	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Enrollment Validations");
	}

	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Enrollment Validations", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "EnrollmentValidation");
	}
}
